import React, { memo } from 'react';
import TableHead from './SubFormHead';
import TableBody from './SubFormBody';


const SubFormTable  = (props)=>{
    const {headProps,bodyProps} = props;
    // console.log('bodyProps',bodyProps);
    return(
        <table className="subformTable table nowrap mb-0 table-striped">
           <TableHead 
                {...headProps} />
            <TableBody 
                {...bodyProps} />  
        </table>
    )
}


// const isDiffProps = (prevProps,nextProps)=>{
//   if(JSON.stringify(prevProps.headProps)===JSON.stringify(nextProps.headProps) && prevProps.bodyProps===nextProps.bodyProps && JSON.stringify(prevProps.headProps.validationForms)===JSON.stringify(nextProps.headProps.validationForms)){
//       return true;
//     }
//   }
export default (SubFormTable);